import { Typography, TypographyProps } from '@mui/material';

type CommonConjunctionProps = TypographyProps & {
  index: number;
  amountOfElements: number;
};

const CommonConjunction = ({
  amountOfElements,
  index,
  ...props
}: CommonConjunctionProps) => {
  if (amountOfElements === 1 || index === amountOfElements - 1) {
    return null;
  }
  return (
    <Typography
      {...props}
      sx={[
        {
          color: 'text.secondary',
          fontSize: 'small'
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx])
      ]}
    >
      oraz
      {
        // {t('COMMON_CONJUNCTION')} todo: task https://drsjira.bestsa3.best.com.pl/browse/SMART-4308
      }
    </Typography>
  );
};

export default CommonConjunction;
